<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <template>
      <el-form ref="editForm"
               :model="editForm"
               class="mobile-show-box form-wrapper"
               :label-width="formLabelWidth">
        <el-form-item label="站点标题">
          <el-input placeholder="请输入标题"
                    v-model="editForm.title"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input placeholder="请输入内容"
                    v-model="editForm.keywords"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input placeholder="请输入内容"
                    v-model="editForm.describe"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini"
                     type="primary"
                     @click="addArt()">提交</el-button>
          <el-button size="mini"
                     @click="back()">取消</el-button>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>
<style lang="less">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
<script>
import axios from 'axios';
import api from '../../api/api';
import navigation from './navigation';

export default {
  data() {
    return {
      id: '',
      formLabelWidth: '80px',
      editForm: {
        keywords: '',
        title: '',
        describe: '',
      },
      linkList: [],
      linkId: '',
      nav: '',
    };
  },
  created() {
    this.editForm.title = localStorage.getItem('title');
    this.editForm.keywords = localStorage.getItem('keywords');
    this.editForm.describe = localStorage.getItem('describe');
  },
  components: {
    navigation,
  },
  methods: {
    back() {
      this.editForm.title = localStorage.getItem('title');
      this.editForm.keywords = localStorage.getItem('keywords');
      this.editForm.describe = localStorage.getItem('describe');
    },
    // 修改设置
    addArt() {
      const that = this;
      const data = Object.assign(this.editForm, {
        wid: this.$store.state.websiteId,
      });

      axios.post(`${api.url}editBasicSet`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert(response.data.msg, '', {
            confirmButtonText: '确定',
            callback: () => {
              this.$store.commit('getTitle', that.editForm.title);
              this.$store.commit('getKeywords', that.editForm.keywords);
              this.$store.commit('getDescribe', that.editForm.describe);
            },
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/websiteConfig/editBasicSet.vue